export const SERVER_DATE_FORMAT = 'yyyy-MM-dd' as const;
export const CLIENT_DATE_FORMAT = 'dd/MM/yyyy' as const;
